import {
  GET_USER_ACTIVITY,
  GET_USER_ACTIVITY_SUCCESS,
  GET_USER_ACTIVITY_ERROR,
  GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY,
  GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS,
  GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR,
  UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY,
  UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS,
  UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR
} from "./actionTypes"

export const getUserActivity = (query_params, paginated) => {
  return {
    type: GET_USER_ACTIVITY,
    payload: query_params,
    paginated: paginated
  }
}

export const getUserActivitySuccess = (event, meta) => ({
  type: GET_USER_ACTIVITY_SUCCESS,
  payload: event,
  meta,
})

export const getUserActivityError = (error) => ({
  type: GET_USER_ACTIVITY_ERROR,
  payload: error
})

export const getAdminUserColumnPreferenceUserActivity = (query_params) => {
  return {
    type: GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY,
    payload: query_params
  }
}

export const getAdminUserColumnPreferenceUserActivitySuccess = (event) => ({
  type: GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS,
  payload: event
})

export const getAdminUserColumnPreferenceUserActivityError = (error) => ({
  type: GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR,
  payload: error
})

export const updateAdminUserColumnPreferenceUserActivity = (query_params) => {
  return {
    type: UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY,
    payload: query_params
  }
}

export const updateAdminUserColumnPreferenceUserActivitySuccess = (event) => ({
  type: UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS,
  payload: event
})

export const updateAdminUserColumnPreferenceUserActivityError = (error) => ({
  type: UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR,
  payload: error
})
